import { put, call, all } from "redux-saga/effects";
import { END_POINTS } from "../../api/endpoints";
import { API } from "../../api/api";
import { getProviderDetailsSuccessAction, getProviderDetailsFailureAction, updateProviderDataSuccessAction, updateProviderDataFailureAction } from "../actions/providerActions";

export function* getProviderDetails() {
    try {
        let baseUrl =
            process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const providerDetailsResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.providerDetails}`
        );

        if (!providerDetailsResponse.success) {
            throw new Error(providerDetailsResponse.message);
        }
        yield put(getProviderDetailsSuccessAction(providerDetailsResponse.data));
    } catch (error) {
        yield put(getProviderDetailsFailureAction(error.message));
    }
}

export function* updateProviderDetails(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const providerDetailsResponse = yield call(
            API.patch,
            `${baseUrl}${END_POINTS.providerDetails}`,
            {
                ...action.payload.body,
            }
        );
        if (!providerDetailsResponse.success) {
            throw new Error(providerDetailsResponse.message);
        }
        yield put(
            updateProviderDataSuccessAction(providerDetailsResponse.data)
        );
        yield put(getProviderDetails())
    } catch (error) {
        yield put(updateProviderDataFailureAction(error.message));
    }
}